<template>
<div>
  <v-row>
    <v-col cols="12" sm="4" dir="rtl">
      <h2 style="text-align: center">{{dvDate}}</h2>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" sm="4" dir="rtl">
      <h2 style="text-align: center">{{branch}}</h2>
    </v-col>
  </v-row>
  <br/><br/>
  <v-row>
    <v-col cols="12" sm="5" dir="rtl">
      <h2 style="text-align: center">{{owner}}</h2>
    </v-col>
    <v-col cols="12" sm="4" dir="rtl">
      <h3 style="text-align: center">{{sheba}}</h3>
      <!-- <h2 style="text-align: center">IR180170000000368537751004</h2> -->
    </v-col>
  </v-row>
  <br/>
  <v-row>
    <v-col cols="12" sm="4" dir="rtl">
      <h3 style="text-align: center">051-33641986</h3>
    </v-col>
    <v-col cols="12" sm="2" dir="rtl">
      <h3 style="text-align: center">بازار رضا پلاک ۲/۶۰۵</h3>
    </v-col>
    <v-col cols="12" sm="4" dir="rtl">
      <h2 style="text-align: center">{{national_code}}</h2>
    </v-col>
  </v-row>
  <br/>
  <v-row>
    <v-col cols="12" sm="6" dir="rtl">
    </v-col>
  </v-row>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <br/>
  <v-row>
    <v-col cols="12" sm="1">
    </v-col>
    <v-col cols="12" sm="10">
      <table dense>
        <tbody>
          <tr v-for="item in items" :key="item._id">
            <td width="15%" style="text-align: right">{{`${item.date}`}}</td>
            <td width="17%" style="text-align: right">{{`${item.serial}`}}</td>
            <td width="17%" style="text-align: center">{{`${item.number}`}}</td>
            <td width="17%" style="text-align: center">{{`${item.bank} ${item.branch}`}}</td>
            <td width="27%" v-if="item.price"><h2>{{`${item.price}` | currencyDisplay }}</h2>
            <td width="27%" v-else><h2></h2>
            </td>
          </tr>
          <tr class="total">
            <td colspan="4"></td>
            <td colspan="1"><h2>{{ total | currencyDisplay }}</h2>
            </td>
          </tr>
        </tbody>
      </table>
    </v-col>
    <!-- <v-col cols="12" sm="1">
    </v-col> -->
  </v-row>
  <v-row>
    <!-- <v-col cols="12" sm="1" dir="rtl">
    </v-col> -->
    <v-col cols="12" sm="10" dir="rtl">
      <h5 style="text-align: right">{{ `${horoof} ریال` }}</h5>
    </v-col>
    <v-col cols="12" sm="2" dir="rtl">
    </v-col>
  </v-row>
</div>
</template>

<script>
import {
  numberToWords,
} from "@persian-tools/persian-tools";
//
export default {
  name: "print-Doc",
  props: ['data', 'dvDate', 'bankAccount'],
  data: () => ({
    owner: null,
    sheba: null,
    national_code: null,
    branch: null,
    items: [],
  }),
  computed: {
    total() {
      let t = 0
      t = this.data.map((item) => {
        if (item.price) {
          return item.price
        } else {
          return 0
        }
      })
      return t.reduce((a, b) => Number(a) + Number(b), 0);
    },
    horoof() {
      return numberToWords(this.total)
    },
  },
  watch: {
    bankAccount(newVal) {
      this.owner = newVal.owner
      this.sheba = newVal.sheba
      this.national_code = newVal.national_code
      this.branch = newVal.branch
    },
    data(newVal) {
      for (var i = 0; i < 4; i++) {
        if (newVal[i]) {
          this.items[i] = newVal[i]
        } else {
          this.items[i] = {
            date: '',
            serial: '',
            number: '',
            bank: '',
            branch: '',
            price: ''
          }
        }
      }
    }
  },
}
</script>

<style type="scss" scoped>
table {
  width: 100%;
  border: none;
  border-spacing: 0;
  border-collapse: collapse;
}

tr td {
  border: none;
  height: 40px;
  /*color: inherit;*/
}
</style>
